export default __webpack_public_path__ + "static/media/bearshaman_color.8c867ff5.png";